export default __webpack_public_path__ + "static/alfred_search_cp-49c05ef1908b764c7efb23bf39816baf.png";